import React from 'react';
import {
  Redirect,
  Switch,
  Route,
} from 'react-router-dom';


import OrdersRoutes from './Containers/Orders/OrdersRoutes';
import FuelFarmRoutes from './Containers/FuelFarm/FuelFarmRoutes';
import FuelTrucksRoutes from './Containers/FuelTrucks/FuelTrucksRoutes';
import ReportRoutes from './Containers/Reports/ReportRoutes';
import SettingsPage from './Containers/Settings/SettingsPage';

import auth from './Containers/Authentication/Auth';
import Logout from './Containers/Authentication/Logout';

import NotFound from './Containers/Misc/NotFound';
import NoFBOPage from './Containers/Authentication/NoFBOPage';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!auth.loggedIn()) return <Redirect to="/login" />;
      if (!auth.hasFbo()) return <Redirect to="/unauthorized" />;

      return <Component {...props} />;
    }}
  />);

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
const Main = () => (
  <div>
    <Switch>
      <Route path="/logout" component={Logout} />
      <Route exact path="/unauthorized" component={NoFBOPage} />
      <PrivateRoute path="/orders" component={OrdersRoutes} />
      <PrivateRoute path="/fuelfarm" component={FuelFarmRoutes} />
      <PrivateRoute path="/fueltrucks" component={FuelTrucksRoutes} />
      <PrivateRoute path="/reports" component={ReportRoutes} />
      <PrivateRoute exact path="/settings" component={SettingsPage} />

      {/* <PrivateRoute exact path="/" component={OrdersPage} /> */}

      <PrivateRoute exact path="/" component={OrdersRoutes} />
      <Route component={NotFound} />
    </Switch>
  </div>
);

export default Main;



// WEBPACK FOOTER //
// ./src/Main.js